import React, {useEffect, useState} from 'react';
import {Route, Routes, useLocation} from 'react-router-dom';
import Home from '../components/Home/Home';
import Login from '../components/Login/Login';
import Signup from '../components/Signup/Signup';
import Categories from '../components/Categories/Categories';
import ServiceProviderSignUp from '../components/ProviderSignUp/ServiceProviderSignUp';
import ProductsProviderSignUp from '../components/ProviderSignUp/ProductsProviderSignUp';
import ProvidersList from "../components/Providers/ProvidersList";
import ProviderProfile from "../components/Providers/ProviderProfile";
import UserProfile from "../components/Profile/UserProfile";
import EditProfile from "../components/Profile/EditProfile"
import EditProviderProfile from "../components/Providers/EditProviderProfile";
import Welcoming from "../components/ControlPanel/Welcoming";
import ControlPanel from "../components/ControlPanel/ControlPanel";
import ProviderSelection from "../components/ProviderSignUp/ProviderSelection";
import RegistrationSuccess from "../components/RegistrationSuccess/RegistrationSuccess";
import ProtectedRoute from "./ProtectedRoute";
import UserNotifications from "../components/Profile/UserNotifications";
import FAQPage from "../components/FAQ/FAQPage";
import PostDetail from "../components/Forum/PostDetail";
import PartnersPage from "../components/Partners/PartnersPage";
import PartnerPanelPage from "../components/Partners/PartnerPanelPage";
//import PrivateRoute from './PrivateRoute'; // para rutas protegidas

const AppRoutes = () => {
        const [hasAccess, setHasAccess] = useState(false);
        const handleAccessGranted = () => {
                setHasAccess(true);
        };
    const { pathname } = useLocation();


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        //<ScrollToTop>
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/login" element={<Login />} />
            <Route
                path="/registro"
                element={
                    <ProtectedRoute requiresAuth={false} redirectTo="/">
                        <Signup />
                    </ProtectedRoute>
                }
            />
            <Route path="/registro/exitoso" element={<RegistrationSuccess />} />
            <Route path="/categorias/:type" element={<Categories />} />
            <Route
                path="/registro/servicios"
                element={
                    <ProtectedRoute requiresAuth={true} redirectTo="/registro">
                        <ServiceProviderSignUp />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/registro/productos"
                element={
                    <ProtectedRoute requiresAuth={true} redirectTo="/registro">
                        <ProductsProviderSignUp />
                    </ProtectedRoute>
                }
            />
            <Route path="/preguntas-frecuentes" element={<FAQPage />} />
            <Route path="/foro/post/:postId" element={<PostDetail />} />
            {/* Alias retrocompat: links viejos /forum/post/... siguen funcionando */}
            <Route path="/forum/post/:postId" element={<PostDetail />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route
                path="/partners/panel"
                element={
                    <ProtectedRoute requiresAuth={true} redirectTo="/login">
                        <PartnerPanelPage />
                    </ProtectedRoute>
                }
            />
            <Route path="/:categoryType/:categoryName/proveedores" element={<ProvidersList />} />
            <Route path="/:providerId" element={<ProviderProfile />} />
            <Route
                path="/usuario/perfil"
                element={
                    <ProtectedRoute requiresAuth={true} redirectTo="/login">
                        <UserProfile />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/usuario/notificaciones"
                element={
                    <ProtectedRoute requiresAuth={true} redirectTo="/login">
                        <UserNotifications />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/usuario/editar"
                element={
                    <ProtectedRoute requiresAuth={true} redirectTo="/login">
                        <EditProfile />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/:providerId/editar"
                element={
                    <ProtectedRoute requiresAuth={true} redirectTo="/login">
                        <EditProviderProfile />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/registro/proveedor"
                element={
                        <ProviderSelection />
                }
            />
                <Route
                    path="/panel/admin/cme"
                    element={
                            hasAccess
                                ? <ControlPanel />
                                : <Welcoming onAccessGranted={handleAccessGranted} />
                    }
                />
            {/*<Route path="/protected" element={<PrivateRoute />}>
            {/*<Route path="/protected/somepage" element={<SomeProtectedComponent />} />
            </Route>*/}
        </Routes>
        //</ScrollToTop>
    );
};

export default AppRoutes;